import type { Theme } from '@emotion/react';
import theme from 'providers/theme/theme';
import type { StyleExtend } from 'providers/theme/theme.types';
import type { FeedbackWrapperProps } from './FeedbackWrapper.types';

export const FeedbackWrapperStackStyles = (
  feedback: FeedbackWrapperProps['feedback'],
): StyleExtend<Theme> => ({
  mt: 9.5,
  border: `1px solid ${theme.palette.customColors.lightGray}`,
  p: theme.spacing(feedback === 'none' ? 6 : 3, 6, 6, 6),
  boxShadow: theme.customStyling.shadow.quoteDetailsCard,
  borderRadius: 1,

  [theme.breakpoints.down('sm')]: {
    p: theme.spacing(3),
    mt: 7,
  },
});

export const ImgWrapperStyles = (
  feedback: FeedbackWrapperProps['feedback'],
): StyleExtend<Theme> => ({
  [`& img`]: {
    maxWidth: theme.spacing(8),
    // Animations have blank spaces around it. These styles forces
    // the animations to align with the rest of the content
    ...((feedback === 'declined' || feedback === 'success') && {
      marginLeft: theme.spacing(-1.5),
      marginTop: theme.spacing(-1.5),
      marginBottom: theme.spacing(-2.25),
    }),
    ...(feedback === 'referred' && {
      marginBottom: theme.spacing(-1.25),
      marginLeft: theme.spacing(-0.25),
    }),
  },
});
